import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';

@Component({
	selector: 'app-modal-nif-expidation-help',
	templateUrl: './modal-nif-expidation-help.component.html',
	styleUrls: ['./modal-nif-expidation-help.component.scss'],
	imports: [ModalComponent, TranslatePipe, PwcsInlineSvgComponent],
})
export class ModalNifExpidationHelpComponent {
	@Input() isVisible: boolean = false;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
